export class Store {
  constructor(initialState, reducer) {
    let [initialState_, effects] = initialState
    this.currentState = initialState_
    this.reducer = reducer
    this.queue = []
    this.enqueued = false
    this.effectDispatch = this.effectDispatch.bind(this)
    this.dispatch = this.dispatch.bind(this)
    this.notifiers = []
    handleEffects(effects, eff =>
      eff.one(this.dispatch, () => this.currentState, this.effectDispatch)
    )
  }

  dispatch(msg) {
    this.queue.push(msg)
    if (this.enqueued) return
    this.enqueued = true
    return new Promise(resolve => {
      window.queueMicrotask(async () => {
        await this.#work()
        resolve()
      })
    })
  }

  async effectDispatch(effects) {
    const effs = []
    handleEffects(effects, eff =>
      effs.push(
        eff.one(this.dispatch, () => this.currentState, this.effectDispatch)
      )
    )
    await Promise.allSettled(effs)
  }

  async #work() {
    const workQueue = [...this.queue]
    this.enqueued = false
    this.queue = []
    for (const work of workQueue) {
      const [state, effects] = this.reducer(this.currentState, work)
      this.currentState = state
      const effs = []
      handleEffects(effects, eff =>
        effs.push(
          eff.one(this.dispatch, () => this.currentState, this.effectDispatch)
        )
      )
      await Promise.allSettled(effs)
    }
    if (!this.enqueued) this.#notify()
  }

  #notify() {
    for (const notifier of this.notifiers) {
      notifier(this.currentState)
    }
  }

  addListener(notifier) {
    this.notifiers.push(notifier)
  }

  removeListener(notifier) {
    this.notifiers = this.notifiers.filter(notif => notif !== notifier)
  }
}

// `effects : Effect(msg) | List(Effect(msg))`
function handleEffects(effects, next) {
  // Effect(msg)
  if ('one' in effects) next(effects)
  // List(Effect(msg))
  if ('all' in effects)
    for (const effect of effects.all) handleEffects(effect, next)
}

export function newStore(initialState, reducer) {
  return new Store(initialState, reducer)
}

export async function dispatch(store, msg) {
  await store.dispatch(msg)
}

export async function effectDispatch(store, msg) {
  await store.effectDispatch(msg)
}

export function addListener(store, notifier) {
  store.addListener(notifier)
}

export function removeListener(store, notifier) {
  store.removeListener(notifier)
}

export function state(store) {
  return store.currentState
}
